export default __webpack_public_path__ + "static/media/AdamBohach.ddd2acaf.jpg";